setWarehouse = ->
  pole = $("#product_set_product_name")
  id = $("#warehouse_id").val()
  pole.attr("data-autocomplete", "/document_items/autocomplete_product_name?set=0&warehouse_id=" + id)

$(document).on 'turbolinks:load', ->
  setWarehouse()